import { Component, OnInit } from '@angular/core';
import {MouseListenersService} from "@src/app/services/mouseListeners/mouse-listeners.service";
import {CesiumAdapterService} from "@src/app/services/cesiumAdapter21/cesium-adapter.service";
import {filter, takeWhile} from "rxjs/operators";
import {interval, Observable, of, Subject, Subscription, timer} from "rxjs";

const leftSidebarWidth = 355;

@Component({
  selector: 'app-map-move',
  templateUrl: './map-move.component.html',
  styleUrls: ['./map-move.component.scss']
})
export class MapMoveComponent implements OnInit {
  private currentEvent:PointerEvent;
  private isIntervalActive$:Subject<boolean> = new Subject<boolean>();
  private currentTimer: Subscription;

  constructor(private ml: MouseListenersService, private ca: CesiumAdapterService) { }

  ngOnInit() {
    this.ml.mouseMove$.pipe(filter(event => this.ca.isDrawingNow && this.ca.isFirstPointSet)).subscribe((event:PointerEvent)=>{
      if (this.isShouldMove(event)){
        if (!this.currentEvent){
          this.isIntervalActive$.next(true);
        }
        this.currentEvent = event;
      }
      else{
        this.currentEvent = null;
        this.isIntervalActive$.next(false);
        if (this.currentTimer){
          this.currentTimer.unsubscribe();
        }
      }
    });

    this.ca.isDrawingFigure.subscribe((val)=>{
      if (!val){
        this.currentEvent = null;
        this.isIntervalActive$.next(false);
      }
    });

    this.isIntervalActive$.pipe(filter(flag => flag)).subscribe((flag)=>{
      this.currentTimer = timer(0, 40).pipe(takeWhile(val => !!this.currentEvent)).subscribe(()=>{
        this.ca.moveCameraBy(this.getOffsetFromEvent());
      })
    });
  }

  isShouldMove(event){
     let getBoundedOffsetInPx = {x: window.innerWidth*0.15, y: window.innerHeight*0.15};
    return parseFloat(event.clientX) > window.innerWidth - getBoundedOffsetInPx.x || parseFloat(event.clientX)-leftSidebarWidth < getBoundedOffsetInPx.x || parseFloat(event.clientY) > window.innerHeight-getBoundedOffsetInPx.y || parseFloat(event.clientY) < getBoundedOffsetInPx.y;
  }

  private getOffsetFromEvent(){
    let resultOffset = {x: 0, y: 0};
    let getBoundedOffsetInPx = {x: window.innerWidth*0.15, y: window.innerHeight*0.15};
    let currentPercentVal = 0;
    let factorInPx = 5;

    if (this.currentEvent.clientX > window.innerWidth-getBoundedOffsetInPx.x){
      currentPercentVal = 15 - (100 - (this.currentEvent.clientX/window.innerWidth*100));
      resultOffset.x += currentPercentVal*factorInPx;
    }
    if (this.currentEvent.clientX-leftSidebarWidth < getBoundedOffsetInPx.x){
      let currentPxClientOffset = this.currentEvent.clientX-leftSidebarWidth;
      if (currentPxClientOffset < 0){
        currentPxClientOffset = 0;
      }
      currentPercentVal = 15 - (currentPxClientOffset/window.innerWidth*100);
      resultOffset.x -= currentPercentVal*factorInPx;
    }
    if (this.currentEvent.clientY > window.innerHeight-getBoundedOffsetInPx.y){
      currentPercentVal = 15 - (100 - (this.currentEvent.clientY/window.innerHeight*100));
      resultOffset.y += currentPercentVal*factorInPx;
    }
    if (this.currentEvent.clientY < getBoundedOffsetInPx.y){
      currentPercentVal = 15 - (this.currentEvent.clientY/window.innerHeight*100);
      resultOffset.y -= currentPercentVal*factorInPx;
    }
    return resultOffset;
  }

}
